import React from 'react'
import CustomAlert from '../../components/shared/CustomAlert'
import DashboardLayout from './../../components/Admin/DashboardLayout'
import UserProfileService from './../../shared/services/UserProfile.service'
import RecentApplications from './components/RecentApplications/RecentApplications.component'
import DateService from './../../shared/services/Date.service'
import { CrmStore } from './../../components/crm'
import MaxAvAgeSetting from './components/MaxAvAgeSetting/MaxAvAgeSetting.component'
import SalesGuidelines from './components/SalesGuidelines/SalesGuidelines.component'
import ResetPointsButton from './components/ResetPointsButton/ResetPointsButton.component'
import SalesTracker from './components/SalesTracker.component'
import SubmitSalesService from './shared/SubmitSales.service'
import { MDBContainer, MDBBtn, MDBRow, MDBCol, MDBCollapse } from 'mdb-react-ui-kit'
import SalesTrackerStore from './store'
import MaxAvDateStore from './store/max-av-date.store'

import './SalesTracker.page.scss'

class SalesTrackerPage extends React.Component {
  isAdmin = false
  avUserId = null

  state = {
    Policy: false,
    loading: true,
    showGuidelines: true,
    enableSalesTracker: false,
    resettingAcceptance: false,
    resetPoints: null,
    canShowGuidelines: false,
    avUserId: null,
    hasAccepted: null,
  }

  /*
   * Component Accessor Methods ----------------------
   *
   */

  /*
   * Component Public Methods ------------------------
   *
   */

  /*
   * Component Private Methods -----------------------
   *
   */

  // useCrm = () => !UserProfileService.isA(['affiliate-group', 'associate-group'])

  // isCrmValid = () => {
  //   return this.useCrm() && CrmStore.Contact && CrmStore.isAssigned
  // }

  showGuidelines = () => this.setShowGuidelines('guidelines')

  hasAccepted = hasAccepted => this.setState({ hasAccepted })

  resetAcceptance = async () => {
    if (this.isAdmin && this.avUserId) {
      this.setState({ resettingAcceptance: true })
      await SubmitSalesService.resetAcceptance(this.avUserId)
      this.setState({ resettingAcceptance: false, hasAccepted: null })
    }
  }

  setShowGuidelines = open => {
    if (open === 'guidelines')
      return this.setState({
        loading: false,
        showGuidelines: true,
        enableSalesTracker: false,
        canShowGuidelines: false,
      })

    if (open === 'form')
      return this.setState({
        loading: false,
        showGuidelines: false,
        enableSalesTracker: true,
        canShowGuidelines: true,
      })
  }

  renderAcceptanceNotification = () => {
    if (this.isAdmin && UserProfileService.isAssumed()) {
      if (this.state.hasAccepted)
        return (
          <CustomAlert color='info' className='text-center'>
            <span style={{ fontWeight: 500 }}>
              The agent accepted the Sales Guidelines on{' '}
              {DateService.dateOnlyToString(this.state.hasAccepted, 'MM/DD/YYYY')}.
            </span>
          </CustomAlert>
        )
      if (!this.state.hasAccepted)
        return (
          <CustomAlert color='danger' className='text-center'>
            <span style={{ fontWeight: 500 }}>The agent has not accepted the Sales Guidelines.</span>
          </CustomAlert>
        )
    }
  }

  renderMaxAgeSetting = () => {
    return <MaxAvAgeSetting />
  }

  renderResetAcceptanceButton = () => {
    if (this.isAdmin && this.avUserId && this.state.hasAccepted && UserProfileService.isAssumed())
      return (
        <MDBBtn
          type='button'
          className='btn-block mb-3'
          disabled={this.state.resettingAcceptance}
          style={{ fontWeight: 500 }}
          color='indigo'
          onClick={() => this.resetAcceptance()}
        >
          {this.state.resettingAcceptance ? 'Resetting ...' : "Reset Agent's Sales Guideline Acceptance"}
        </MDBBtn>
      )
  }

  initCrm = async () => {
    if (UserProfileService.isA(['affiliate-group', 'associate-group'])) return false

    return await CrmStore.init()
  }

  initPolicy = async avId => {
    SalesTrackerStore.reset()
    SalesTrackerStore.setClientType('individual')
    SalesTrackerStore.fetchById(avId)
      .then(async Policy => {
        if (Policy && Policy.get('user_id')) {
          await MaxAvDateStore.fetchMaxAvAge(Policy.get('user_id'))
          MaxAvDateStore.setPolicy(SalesTrackerStore.Policy)
        }
        this.setState({ Policy })
      })
      .finally(() => {
        SalesTrackerStore.determineSellingAgents().then(AOR => {
          SalesTrackerStore.setSellingAgents(AOR)
          SalesTrackerStore.fetchAgentCarrierContracts()
        })
      })
  }

  initSalesTracker = async avId => {}

  updateSalesTracker = async avId => {}

  /*
   * Component Event Methods -------------------------
   *
   */
  componentDidMount() {
    this.isAdmin = UserProfileService.isA(['system-admin', 'agency-owner', 'internal-admin'], true)
    this.avUserId = UserProfileService.getUserId()

    const {
      match: { params },
    } = this.props

    this.initPolicy(params && params?.id)

    Promise.all([
      this.initCrm(),
      SalesTrackerStore.fetchCarriers(),
      SalesTrackerStore.fetchPointOverrides(),
      SalesTrackerStore.fetchCoverages(),
      SalesTrackerStore.fetchLeadSources(),
    ])
  }

  componentDidUpdate(prevProps) {
    const {
      match: { params },
    } = this.props
    const prevParams = prevProps.match.params

    // If going from edit mode to new mode, reset the store
    if (prevParams?.id && !params?.id) {
      SalesTrackerStore.fetchById(null)
    }

    Promise.all([SalesTrackerStore.fetchPointOverrides()])
  }

  componentWillUnmount() {
    CrmStore.resetContact()
    SalesTrackerStore.reset()
  }

  render() {
    return (
      <React.Fragment>
        <DashboardLayout>
          <main id='SalesTrackerPage' className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>Submit Sales</h2>
              <hr />

              {/* (Collapsible) Sales Tracker Guildelines. */}
              <MDBCollapse open={this.state.showGuidelines}>
                <MDBRow>
                  <MDBCol size='12'>
                    <SalesGuidelines open={this.setShowGuidelines} hasAccepted={this.hasAccepted} />
                  </MDBCol>
                </MDBRow>
              </MDBCollapse>

              {/* (Collapsible) Sales Tracker Forms. */}
              <MDBCollapse open={this.state.enableSalesTracker}>
                <MDBRow>
                  <MDBCol size='12' sm='7' lg='8'>
                    <div className='content-wrapper'>
                      <SalesTracker
                        Policy={this.state.Policy}
                        reset={() => {
                          CrmStore.resetContact()
                          this.setState({ Policy: false }, () => this.props.history.push(`/submit-sales`))
                        }}
                      />
                    </div>
                  </MDBCol>
                  <MDBCol size='12' sm='5' lg='4'>
                    {this.state.canShowGuidelines ? (
                      <MDBBtn
                        type='button'
                        className='btn-block mb-3'
                        style={{ fontWeight: 500 }}
                        color='indigo'
                        onClick={() => this.showGuidelines()}
                      >
                        Show Sales Guidelines
                      </MDBBtn>
                    ) : (
                      <></>
                    )}
                    <ResetPointsButton />
                    {this.renderAcceptanceNotification()}
                    {this.renderMaxAgeSetting()}
                    {this.renderResetAcceptanceButton()}
                    <RecentApplications
                      goTo={avId => {
                        this.initPolicy(avId)
                        this.props.history.push(`/submit-sales/${avId}/edit`)
                      }}
                    />
                  </MDBCol>
                </MDBRow>
              </MDBCollapse>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </React.Fragment>
    )
  }
}

export default SalesTrackerPage
